(function () {
  'use strict';

  if (window.__rgSeptemberGiveawayPopupInitialized) return;
  window.__rgSeptemberGiveawayPopupInitialized = true;

  var popup = document.querySelector('[data-rg-september-popup]');
  if (!popup) return;

  var deadline = new Date(popup.getAttribute('data-entry-deadline') || '').getTime();
  if (Number.isFinite(deadline) && Date.now() >= deadline) return;

  var closeButton = popup.querySelector('[data-rg-popup-close]');
  var dialog = popup.querySelector('[role="dialog"]');
  var closedKey = 'rgSeptemberGiveawayPopupClosed2026';
  var sessionKey = 'rgSeptemberGiveawayPopupSeen2026';
  var loadedAt = Date.now();
  var previousFocus = null;
  var shown = false;
  var query = new URLSearchParams(window.location.search);
  var hasFormFeedback = Boolean(popup.querySelector('[data-rg-entry-success], [data-rg-entry-errors]'));
  var forceOpen = query.get('rg-september-popup') === '1' || query.get('contact_posted') === 'true' || hasFormFeedback;

  if (!forceOpen) {
    try {
      var closedAt = parseInt(localStorage.getItem(closedKey) || '0', 10);
      if (sessionStorage.getItem(sessionKey) === '1') return;
      if (closedAt && Date.now() - closedAt < 24 * 60 * 60 * 1000) return;
    } catch (error) {}
  }

  function focusable() {
    return Array.prototype.slice.call(
      popup.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])')
    ).filter(function (element) {
      return element.offsetParent !== null;
    });
  }

  function show() {
    if (shown || !popup.hidden) return;
    if (Number.isFinite(deadline) && Date.now() >= deadline) return;
    shown = true;
    previousFocus = document.activeElement;
    popup.hidden = false;
    document.body.classList.add('rg-september-giveaway-popup-open');
    try {
      sessionStorage.setItem(sessionKey, '1');
    } catch (error) {}
    window.setTimeout(function () {
      if (hasFormFeedback) {
        var feedback = popup.querySelector('[data-rg-entry-success], [data-rg-entry-errors]');
        if (feedback) feedback.focus();
      } else if (closeButton) {
        closeButton.focus();
      } else if (dialog) {
        dialog.focus();
      }
    }, 60);
  }

  function close() {
    popup.hidden = true;
    document.body.classList.remove('rg-september-giveaway-popup-open');
    try {
      localStorage.setItem(closedKey, String(Date.now()));
    } catch (error) {}
    if (previousFocus && previousFocus.focus) previousFocus.focus();
  }

  if (closeButton) closeButton.addEventListener('click', close);
  popup.addEventListener('click', function (event) {
    if (event.target === popup) close();
  });
  document.addEventListener('keydown', function (event) {
    if (popup.hidden) return;
    if (event.key === 'Escape') {
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    var elements = focusable();
    if (!elements.length) return;
    var first = elements[0];
    var last = elements[elements.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  if (forceOpen) {
    show();
    return;
  }

  window.addEventListener('scroll', function () {
    if (Date.now() - loadedAt >= 12000 && window.scrollY >= 420) show();
  }, { passive: true });
  document.addEventListener('mousemove', function (event) {
    if (Date.now() - loadedAt >= 12000 && event.clientY <= 12 && window.innerWidth > 768) show();
  });
  window.setTimeout(show, 26000);
})();
